<template>
    <div class="footer text-center">
        <div class="screen">
            <div>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021102001177">
                    <img style="width: 12px; height: 12px; margin-bottom: 2px;" src="../assets/img/beian.png"/>&nbsp;苏公网安备32021102001177号
                </a>
            </div>
            <div>
                Copyright © 2021 无锡砚溪书院 <a target="_blank" href="http://beian.miit.gov.cn">苏ICP备2021022014号-1</a>
            </div>
        </div>
        <div class="wideScreen">
            Copyright © {{curYear}} 无锡砚溪书院 &nbsp;
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021102001177">
                <img style="width: 12px; height: 12px; margin-bottom: 2px;" src="../assets/img/beian.png"/>&nbsp;苏公网安备32021102001177号
            </a>
            <a target="_blank" href="http://beian.miit.gov.cn">苏ICP备2021022014号-1</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
		data() {
			return {
				curYear: '',
			}
		},
		mounted() {
			let curDate = new Date();
			this.curYear = curDate.getFullYear();
		}
    }
</script>

<style scoped>
    .footer{
        z-index: 30;
        width: 100%;
        color: #8e9e83;
        font-size: 12px;
        position:fixed;
        left:0;
        bottom:2px;
    }
    .footer a{ color: #425c73; text-decoration: none !important; transition: all 0.3s linear; }
    .footer a:hover{ color: #8e9e83; }
    @media (max-width: 600px) {
        .wideScreen{ display: none; }
    }
    @media (min-width: 601px) {
        .screen{ display: none; }
    }
</style>
